import {
  errorMetaData,
  pendingMetaData,
  successMetaData,
} from "@workspace/common";
import {
  TAG_JOB,
  TAG_JOB_SUCCESS,
  TAG_JOB_FAILURE,
  TAG_JOB_ALL,
  TAG_JOB_ALL_SUCCESS,
  TAG_JOB_ALL_FAILURE,
  TAG_JOB_FILES,
  TAG_JOB_FILES_SUCCESS,
  TAG_JOB_FILES_FAILURE,
  TAG_JOB_FILES_RESET,
  FETCH_JOB_TIMELINE_LIST,
  FETCH_JOB_TIMELINE_LIST_SUCCESS,
  FETCH_JOB_TIMELINE_LIST_FAILURE,
  JOB_TIMELINE_COUNT,
  JOB_TIMELINE_COUNT_SUCCESS,
  JOB_TIMELINE_COUNT_FAILURE,
  TAG_JOB_RESET,
  TAG_JOB_ATTACHMENT,
  TAG_JOB_ATTACHMENT_SUCCESS,
  TAG_JOB_ATTACHMENT_FAILURE,
  TAG_JOB_ATTACHMENT_RESET,
  UNTAG_JOB,
  UNTAG_JOB_SUCCESS,
  UNTAG_JOB_FAILURE,
  UNTAG_JOB_RESET,
  FETCH_JOB_TIMELINE_FORM_SUBMISSION,
  FETCH_JOB_TIMELINE_FORM_SUBMISSION_SUCCESS,
  FETCH_JOB_TIMELINE_FORM_SUBMISSION_FAILURE,
  FETCH_JOB_TIMELINE_FORM_SUBMISSION_RESET,
  UPDATE_BILL_RATE,
  UPDATE_BILL_RATE_SUCCESS,
  UPDATE_BILL_RATE_FAILURE,
  UPDATE_BILL_RATE_RESET,
  FETCH_JOB_CANDIDATE_STAGE,
  FETCH_JOB_CANDIDATE_STAGE_SUCCESS,
  SET_APPROVE_TAG_SUCCESS,
  RESET_APPROVE_TAG_SUCCESS,
  UPLOAD_PRE_OFFER_FILES,
  UPLOAD_PRE_OFFER_FILES_SUCCESS,
  UPLOAD_PRE_OFFER_FILES_FAILURE,
  UPLOAD_PRE_OFFER_FILES_RESET,
} from "./actionTypes";

const initialState = {
  jobTag: {},
  jobTagMeta: {},
  jobAllTag: {},
  jobAllTagMeta: {},
  jobUntagMeta: {},
  jobTimeline: {},
  jobTimelineMeta: {},
  jobTimelineCount: [],
  jobTimelineCountMeta: {},
  updateBillrateMeta: {},
  jobTimelineFormSubmission: null,
  jobTimelineAll: {},
  jobTimelineFormSubmissionObj: {},
  jobCandidateStageData: {},
  approveTagSuccess: false,
  uploadPreofferDocs: {},
  uploadPreofferDocsMeta: {},
};

const JobStageReducer = (state = initialState, action) => {
  switch (action.type) {
    // tag a job
    case TAG_JOB:
      return {
        ...state,
        jobTagMeta: { ...pendingMetaData(), jobType: action.payload.jobType },
      };
    case TAG_JOB_SUCCESS:
      return {
        ...state,
        jobTagMeta: successMetaData(action.payload),
        jobTag: action.payload,
      };
    case TAG_JOB_FAILURE:
      return {
        ...state,
        jobTagMeta: errorMetaData(action.payload),
      };
    case TAG_JOB_RESET:
      return {
        ...state,
        jobTagMeta: {},
        jobAllTagMeta: {},
      };

    // tag all job
    case TAG_JOB_ALL:
      return {
        ...state,
        jobAllTagMeta: pendingMetaData(),
      };
    case TAG_JOB_ALL_SUCCESS:
      return {
        ...state,
        jobAllTagMeta: successMetaData(action.payload),
        jobAllTag: action.payload,
      };
    case TAG_JOB_ALL_FAILURE:
      return {
        ...state,
        jobAllTagMeta: errorMetaData(action.payload),
      };

    // untag a job
    case UNTAG_JOB:
      return {
        ...state,
        jobUntagMeta: pendingMetaData(),
      };
    case UNTAG_JOB_SUCCESS:
      return {
        ...state,
        jobUntagMeta: successMetaData(action.payload),
      };
    case UNTAG_JOB_FAILURE:
      return {
        ...state,
        jobUntagMeta: errorMetaData(action.payload),
      };
    case UNTAG_JOB_RESET:
      return {
        ...state,
        jobUntagMeta: {},
      };

    // Fetch job timeline
    case FETCH_JOB_TIMELINE_LIST:
      return {
        ...state,
        jobTimelineMeta: pendingMetaData(),
      };
    case FETCH_JOB_TIMELINE_LIST_SUCCESS:
      // Transformation function
      const transformTimelineData = (timeline) => {
        const transformedTimeline = {};

        Object.keys(timeline).forEach((stage) => {
          const latestStageData = timeline[stage].sort(
            (a, b) => b.date - a.date
          )[0];
          transformedTimeline[stage] = latestStageData;
        });

        return transformedTimeline;
      };

      const jobTimeLineNewData = action.payload;
      const transformedJobTimeLineData = {
        ...jobTimeLineNewData,
        jobs: jobTimeLineNewData?.jobs?.map((job) => {
          const transformedTimeline = transformTimelineData(job.timeline);
          return {
            ...job,
            timeline: transformedTimeline,
          };
        }),
      };

      return {
        ...state,
        jobTimelineMeta: successMetaData(action.payload),
        // jobTimeline: action.payload,
        jobTimeline: transformedJobTimeLineData,
        jobTimelineAll: action.payload,
      };
    case FETCH_JOB_TIMELINE_LIST_FAILURE:
      return {
        ...state,
        jobTimeline: {},
        jobTimelineMeta: errorMetaData(action.payload),
        jobTimelineAll: {},
      };

    // Fetch job timeline count
    case JOB_TIMELINE_COUNT:
      return {
        ...state,
        jobTimelineCount: [],
        jobTimelineCountMeta: pendingMetaData(),
      };
    case JOB_TIMELINE_COUNT_SUCCESS:
      return {
        ...state,
        jobTimelineCountMeta: successMetaData(action.payload),
        jobTimelineCount: action.payload,
      };
    case JOB_TIMELINE_COUNT_FAILURE:
      return {
        ...state,
        jobTimelineCount: [],
        jobTimelineCountMeta: errorMetaData(action.payload),
      };
    case TAG_JOB_ATTACHMENT:
      return {
        ...state,
        jobTagMeta: pendingMetaData(),
      };
    case TAG_JOB_ATTACHMENT_SUCCESS:
      return {
        ...state,
        jobTagMeta: successMetaData(action.payload),
        jobTag: action.payload,
      };
    case TAG_JOB_ATTACHMENT_FAILURE:
      return {
        ...state,
        jobTagMeta: errorMetaData(action.payload),
      };
    case TAG_JOB_ATTACHMENT_RESET:
      return {
        ...state,
        jobTagMeta: {},
      };
    case TAG_JOB_FILES:
      return {
        ...state,
        jobTagMeta: pendingMetaData(),
      };
    case TAG_JOB_FILES_SUCCESS:
      return {
        ...state,
        jobTagMeta: successMetaData(action.payload),
        jobTag: action.payload,
      };
    case TAG_JOB_FILES_FAILURE:
      return {
        ...state,
        jobTagMeta: errorMetaData(action.payload),
      };
    case TAG_JOB_FILES_RESET:
      return {
        ...state,
        jobTagMeta: {},
      };
    // Fetch job timeline form submission
    case FETCH_JOB_TIMELINE_FORM_SUBMISSION:
      return {
        ...state,
        jobTimelineFormSubmission: null,
      };
    case FETCH_JOB_TIMELINE_FORM_SUBMISSION_SUCCESS:
      const formSubmission = action.payload;
      const newFormSubmissionObj = JSON.parse(
        JSON.stringify(state.jobTimelineFormSubmissionObj)
      );
      let formKey = "undefined";
      if (formSubmission?.vendorNames) {
        formKey = "Pre-Offer Verification";
      } else if (formSubmission?.accountName) {
        formKey = "TOS";
      }
      newFormSubmissionObj[`${formKey}`] = formSubmission;
      return {
        ...state,
        jobTimelineFormSubmission: action.payload || null,
        jobTimelineFormSubmissionObj: newFormSubmissionObj,
      };
    case FETCH_JOB_TIMELINE_FORM_SUBMISSION_FAILURE:
      return {
        ...state,
        jobTimelineFormSubmission: null,
      };
    case FETCH_JOB_TIMELINE_FORM_SUBMISSION_RESET:
      return {
        ...state,
        jobTimelineFormSubmission: null,
      };

    // update bull rate
    case UPDATE_BILL_RATE:
      return {
        ...state,
        updateBillrateMeta: pendingMetaData(),
      };
    case UPDATE_BILL_RATE_SUCCESS:
      return {
        ...state,
        updateBillrateMeta: successMetaData(action.payload),
      };
    case UPDATE_BILL_RATE_FAILURE:
      return {
        ...state,
        updateBillrateMeta: errorMetaData(action.payload),
      };
    case UPDATE_BILL_RATE_RESET:
      return {
        ...state,
        updateBillrateMeta: {},
      };
    case FETCH_JOB_CANDIDATE_STAGE_SUCCESS:
      return {
        ...state,
        jobCandidateStageData: action.payload,
      };
    case SET_APPROVE_TAG_SUCCESS:
      return {
        ...state,
        approveTagSuccess: true,
      };
    case RESET_APPROVE_TAG_SUCCESS:
      return {
        ...state,
        approveTagSuccess: false,
      };
    case UPLOAD_PRE_OFFER_FILES:
      return {
        ...state,
        uploadPreofferDocsMeta: pendingMetaData(),
      };
    case UPLOAD_PRE_OFFER_FILES_SUCCESS:
      return {
        ...state,
        uploadPreofferDocsMeta: successMetaData(action.payload),
        uploadPreofferDocs: action.payload,
      };
    case UPLOAD_PRE_OFFER_FILES_FAILURE:
      return {
        ...state,
        uploadPreofferDocsMeta: errorMetaData(action.payload),
      };
    case UPLOAD_PRE_OFFER_FILES_RESET:
      return {
        ...state,
        uploadPreofferDocsMeta: {},
      };
    default:
      return state;
  }
};

export default JobStageReducer;
